'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _jsSha = require('js-sha256');

var Cookies = window.Cookies;

var emailSlideUpCookiev3 = Cookies.get('emailSlideUpCookiev3');
var firstPageVisited = Cookies.get('firstPageVisited');

var hideEmailSlideUp = function hideEmailSlideUp(initial) {
  if (initial) {
    $('.email-signup').removeClass('is-active');
  } else {
    setTimeout(function () {
      $('.email-signup').removeClass('is-active');
    }, 5000);
  }
  hideEmailHandler();
};

var showEmailSlideUp = function showEmailSlideUp() {
  $('.email-signup').addClass('is-active');
  Cookies.set('emailSlideUpCookiev3', 'false', { expires: 365 });
};

var hideEmailHandler = function hideEmailHandler() {
  if (emailSlideUpCookiev3 === undefined) {
    Cookies.set('emailSlideUpCookiev3', 'false', { expires: 365 });
  }
};

var initialSlideout = function initialSlideout() {
  if (emailSlideUpCookiev3 == undefined) {
    if (window.slideUp === 'pageload') {
      setTimeout(function () {
        showEmailSlideUp();
      }, 1);
    } else if (window.slideUp === '3 sec delay') {
      setTimeout(function () {
        showEmailSlideUp();
      }, 3000);
    } else if (window.slideUp === 'second page visit') {
      if (firstPageVisited !== 'true') {
        Cookies.set('firstPageVisited', 'true', { expires: 365 });
      } else {
        setTimeout(function () {
          showEmailSlideUp();
        }, 1);
      }
    }
  }
};

var checkEmail = function checkEmail(emailAddress) {
  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

  return regex.test(emailAddress);
};

var bindUIActions = function bindUIActions() {

  $('#footer-email-field').on('keyup', function (event) {
    if (event.which === 13) {
      $('.action_button').click();
    }
  });

  $('.action_button').on('click', function (_ref) {
    var self = _ref.currentTarget;

    var value = $('#footer-email-field').val();
    var hasDot = false;var hasAt = false;

    hasDot = value.indexOf('.') > -1;
    hasAt = value.indexOf('@') > -1;
    if (hasDot && hasAt) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
        $(undefined).removeClass('disabled');
      }
    } else {
      $(undefined).addClass('disabled');
    }

    if ($(undefined).hasClass('disabled')) {
      $('.footer-signup .error_message').text('Please enter a valid email').show();
      $('.footer-signup .success_message').hide();
    } else {
      $('.footer-signup .error_message').hide();
      $('#overlay').addClass('is-active footer-form-overlay');
      $('.footer-more-fields').addClass('is-active');
      var $emailCapture = $('.footer-email').val();

      $('#k_id_email').attr('value', $emailCapture);
    }
  });

  $(document).on('click', '.footer-form-overlay', function () {
    var formIsVisible = $('.footer-more-fields').hasClass('is-active');

    if (formIsVisible) {
      $('#email_signup_footer').submit();
    }
    $('.footer-more-fields').removeClass('is-active');
  });

  $('.close-footer-more').on('click', function () {
    $('#email_signup_footer').submit();
  });

  $('[data-email-close]').on('click', function () {
    hideEmailSlideUp(true);
  });

  $('#email_signup_footer_only_email').on('submit', function (event) {
    var self = event.currentTarget;


    event.preventDefault();
    var $emailFormEl = $(self);
    var email = $(self).find('[type="email"]').val();

    if (checkEmail(email)) {
      var emailCaptured = (0, _jsSha.sha256)(email.toLowerCase());

      window.DY.API('event', {
        name: 'Newsletter Subscription',
        properties: {
          dyType: 'newsletter-subscription-v1',
          hashedEmail: emailCaptured // SHA256 encoding of the lowercase e-mail,
          // in textual hexadecimal representation
        }
      });
      var brontoPixelSrc = 'http://app.bronto.com/public/?q=direct_add&fn=Public_DirectAddForm&id=bugdfkoneetzmqauhdkyeptcyopxbgj&email=' + email + '&createCookie=1&field1=firstname,set,' + 'null' + '&field2=lastname,set,null&field3=gender,set,' + 'null' + '&field4=birthday,set,' + 'null' + '&list1=0bd803ec000000000000000000000009cb27';
      var brontoPixel = $('<img />', {
        src: brontoPixelSrc,
        width: 0,
        height: 0,
        border: 0,
        alt: ''
      });

      brontoPixel.appendTo('body');
      setTimeout(function () {
        $emailFormEl.closest('.email-signup').find('.email-signup--content-static, .email-signup--content-error').hide();
        $emailFormEl.closest('.email-signup').find('.email-signup--content-success').show();
        hideEmailSlideUp();
      }, 1500);
      $(window).on('scroll', function () {
        $('.email-signup').removeClass('is-active');
      });
    } else {
      $(self).closest('.email-signup').find('.email-signup--content-error').show();
    }
  });

  $('#email_signup_footer').on('submit', function (event) {
    event.preventDefault();

    var email = $('.footer-email').val();
    var name = $('#k_id_name').val();
    var gender = $('.footer-more-gender-select').val();
    var bdayMonth = $('.footer-bday-month').val();
    var bdayDay = $('.footer-bday-day').val();
    var bdayYear = $('.footer-bday-year').val();
    var bdayString = bdayMonth + '/' + bdayDay + '/' + bdayYear;
    var brontoPixelSrc = 'http://app.bronto.com/public/?q=direct_add&fn=Public_DirectAddForm&id=bugdfkoneetzmqauhdkyeptcyopxbgj&email=' + email + '&createCookie=1&field1=firstname,set,' + name + '&field2=lastname,set,null&field3=gender,set,' + gender + '&field4=birthday,set,' + bdayString + '&list1=0bd803ec000000000000000000000007e8b9';
    var brontoPixel = $('<img />', {
      src: brontoPixelSrc,
      width: 0,
      height: 0,
      border: 0,
      alt: ''
    });

    brontoPixel.appendTo('body');
    $('#overlay').removeClass('is-active footer-form-overlay');
    $('.footer-more-fields').removeClass('is-active');
    $('.footer-signup .error_message').hide();
    $('.footer-signup .success_message').text('Thank you for signing up!').fadeIn(300);
    $('.email.contact_email.footer-email').val('');
  });
};

var init = exports.init = function init() {
  bindUIActions();
  initialSlideout();
};

exports.default = {
  init: init,
  showEmailSlideUp: showEmailSlideUp
};